import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeviceList from './DeviceList';
import { CloseCircleOutlined, DownOutlined, FolderOpenFilled, PrinterFilled, UpOutlined } from '@ant-design/icons';
import { Button, Dropdown, Input, Menu, Modal, Radio, Select, Tabs, Tooltip, Typography, Alert } from 'antd';
import $ from 'jquery';
import { Api } from '../../../lib/api';
import { DEVICE_TYPE_ID__PRINTER, DEVICE_TYPE_ID__FILE_STORE } from '@shared/constants/constants';
import { Spin } from 'antd';
import { HardwareContext } from '../../../context/HardwareContext';

const SELECTION__PRINT = 'SELECTION__PRINT';
const SELECTION__EXPORT = 'SELECTION__EXPORT';
const REDISCOVER_TIMEOUT_MS = 5000;

const { TabPane } = Tabs;

const { Text } = Typography;

const exportToolTip = 'When test plans are completed, labels are automatically exported to the provided path. ';

class Station extends Component {
    static contextType = HardwareContext;

    static propTypes = {
        stationId: PropTypes.number.isRequired,
        deviceTypes: PropTypes.array
    };

    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.state = {
            collapsed: false,
            newName: null,
            modalVisible: false,
            modalSelection: SELECTION__PRINT,
            modalSelectedPrinter: null,
            printers: [],
            visible: false,
            visibleRename: false,
            discoverVisible: false,
            disableRediscover: false,
            manualVisible: false,
            claimedManually: false,
            deviceIp: '',
            error: false,
            loading: false,
            pushVisible: false,
            testPlans: {},
            testPlanUUID: '',
            serialNumScheme: '',
            serialNum: '',
            testBlocks: [],
            pathValid: false
        };
    }

    getStation() {
        return this.context.stations.byId[this.props.stationId];
    }

    getPeripherals() {
        return this.context.peripherals.byId;
    }

    getDevices() {
        return this.context.devices.byId;
    }

    async assignDeviceManually(deviceIp) {
        //e.preventDefault();
        //check if the devices is from the mdns scan or from device table
        const { fetchDevices, assignDeviceToStation } = this.context;
        this.setState({ loading: true });
        await Api.assignServer(deviceIp, 80).then((result) => {
            if (result === undefined) {
                this.setState({ claimedManually: false, error: true });
            } else if (result.success === 1) {
                this.setState({ claimedManually: true, error: false });
            }
        });
        if (this.state.claimedManually) {
            setTimeout(
                () =>
                    fetchDevices().then((result) => {
                        if (result?.devices) {
                            result.devices.forEach((dev) => {
                                if (dev.ipAddress === deviceIp) {
                                    assignDeviceToStation(dev.id, this.props.stationId);
                                }
                            });
                        }
                    }),
                2000
            );
        }
        if (this.state.error === false) {
            this.setState({ manualVisible: false, deviceIp: '' });
        }
        this.setState({ loading: false });
    }

    onClick = () => {
        $(this.ref.current).slideToggle();
        this.setState((state) => {
            return {
                collapsed: !state.collapsed
            };
        });
    };

    onDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    };

    onDrop = (e) => {
        e.preventDefault();
        let deviceId = parseInt(e.dataTransfer.getData('text/plain'), 10);
        this.context.assignDeviceToStation(deviceId, this.props.stationId);
    };

    handleDeleteStation = () => {
        this.context.deleteStation(this.props.stationId);
    };

    saveNewName = (e) => {
        e.stopPropagation();

        this.context.renameStation(this.props.stationId, this.state.newName);
    };

    handleOk = (e) => {
        this.handleDeleteStation();
        this.setState({
            visible: false
        });
    };

    handleRenameOk = (e) => {
        this.context.renameStation(this.props.stationId, this.state.newName);

        this.setState({
            visibleRename: false
        });
    };

    getTestPlans() {
        Api.getTestPlans().then((testPlans) => {
            this.setState({ testPlans: testPlans });
        });
    }

    async assignPrinterToStation(printerName, stationId) {
        let peripherals = await Api.getPeripherals();
        let peripheralId = null;

        for (let peripheral of peripherals) {
            if (peripheral.deviceTypeId === DEVICE_TYPE_ID__PRINTER && peripheral.name === printerName) {
                peripheralId = peripheral.id;
                break;
            }
        }

        if (peripheralId === null) {
            let response = await Api.createPeripheral(DEVICE_TYPE_ID__PRINTER, printerName);
            peripheralId = response.id;
        }

        await Api.assignPeripheral(peripheralId, stationId);
    }

    async assignExportLocationToStation(exportLocation, stationId) {
        let peripherals = await Api.getPeripherals();
        let peripheralId = null;

        for (let peripheral of peripherals) {
            if (peripheral.deviceTypeId === DEVICE_TYPE_ID__FILE_STORE && peripheral.name === exportLocation) {
                peripheralId = peripheral.id;
                break;
            }
        }

        if (peripheralId === null) {
            let response = await Api.createPeripheral(DEVICE_TYPE_ID__FILE_STORE, exportLocation);
            peripheralId = response.id;
        }

        await Api.assignPeripheral(peripheralId, stationId);
    }

    render() {
        const station = this.getStation();
        const peripherals = this.getPeripherals();
        const devices = this.getDevices();
        const { fetchPeripherals, fetchStations } = this.context;

        return (
            <div
                className={station.name !== 'Local Station' ? 'station' : ''}
                onDragOver={(e) => this.onDragOver(e)}
                onDrop={(e) => {
                    this.onDrop(e);
                }}
            >
                {station.name === 'Local Station' ? (
                    <></>
                ) : (
                    <React.Fragment>
                        <Modal
                            title={
                                <div className="title">
                                    Device Discovery
                                </div>
                            }
                            wrapClassName="device-discovery-modal"
                            open={this.state.discoverVisible}
                            width={1100}
                            onOk={() => this.setState({ discoverVisible: false })}
                            onCancel={() => this.setState({ discoverVisible: false })}
                            footer={
                                <div className="footer">
                                    <div className="buttons">
                                        <Button
                                            disabled={this.state.disableRediscover}
                                            onClick={() => {
                                                this.setState({ disableRediscover: true });
                                                setTimeout(
                                                    () => this.setState({ disableRediscover: false }),
                                                    REDISCOVER_TIMEOUT_MS
                                                );
                                                Api.mdnsScan();
                                            }}
                                        >
                                            Refresh
                                        </Button>
                                        <Button onClick={() => this.setState({ manualVisible: true })}>Assign Manually </Button>
                                        <Button type="primary" onClick={() => this.setState({ discoverVisible: false })}>
                                            Close
                                        </Button>
                                    </div>
                                </div>
                            }
                            closable={true}
                            destroyOnClose={true}
                        >
                            <DeviceDiscovery
                                deviceTypes={this.props.deviceTypes}
                                devices={Object.values(devices).map((device) =>
                                    device.stationId !== null ? device.uid : null
                                )}
                                stationId={this.props.stationId}
                            />
                        </Modal>
                        {/* Print / Export modal window*/}
                        <Modal
                            title={
                                <div className="title">
                                    Print/Export
                                </div>
                            }
                            wrapClassName="print-export-modal"
                            open={this.state.modalVisible}
                            width={500}
                            onOk={() => this.setState({ modalVisible: false })}
                            onCancel={() => this.setState({ modalVisible: false })}
                            footer={
                                <div className="footer">
                                    <div className="buttons">
                                        <Button
                                            type="primary"
                                            disabled={
                                                (this.state.modalSelection === SELECTION__PRINT &&
                                                    this.state.modalSelectedPrinter === null) ||
                                                (this.state.modalSelection === SELECTION__EXPORT &&
                                                    (this.state.modalExportLocation === null ||
                                                        this.state.modalExportLocation === '' ||
                                                        !this.state.pathValid))
                                            }
                                            onClick={() => {
                                                if (
                                                    this.state.modalSelection === SELECTION__PRINT &&
                                                    this.state.modalSelectedPrinter !== null
                                                ) {
                                                    this.assignPrinterToStation(
                                                        this.state.modalSelectedPrinter,
                                                        station.id
                                                    ).then(() => {
                                                        // Close modal
                                                        this.setState({ modalVisible: false });

                                                        // Refresh peripheral list
                                                        fetchPeripherals();
                                                        fetchStations();
                                                    });
                                                } else if (
                                                    this.state.modalSelection === SELECTION__EXPORT &&
                                                    this.state.modalExportLocation !== null &&
                                                    this.state.modalExportLocation !== ''
                                                ) {
                                                    this.assignExportLocationToStation(
                                                        this.state.modalExportLocation,
                                                        station.id
                                                    ).then(() => {
                                                        // Close modal
                                                        this.setState({ modalVisible: false });

                                                        // Refresh peripheral list
                                                        fetchPeripherals();
                                                        fetchStations();
                                                    });
                                                }
                                            }}
                                        >
                                            Add
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                this.setState({ modalVisible: false });
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            }
                            closable={false}
                            destroyOnClose={true}
                        >
                            <Radio.Group
                                className="print-export-selector"
                                buttonStyle="solid"
                                defaultValue={this.state.modalSelection}
                                onChange={(e) => {
                                    this.setState({ modalSelection: e.target.value });
                                }}
                            >
                                <Radio.Button value={SELECTION__PRINT}>Print</Radio.Button>
                                <Tooltip title={exportToolTip}>
                                    <Radio.Button value={SELECTION__EXPORT}>Export</Radio.Button>
                                </Tooltip>{' '}
                            </Radio.Group>

                            {
                                // Printer section
                                this.state.modalSelection === SELECTION__PRINT && (
                                    <React.Fragment>
                                        <div>Printer:</div>

                                        <Select
                                            defaultValue={this.state.modalSelectedPrinter}
                                            onChange={(value) => this.setState({ modalSelectedPrinter: value })}
                                        >
                                            {this.state.printers.map((printer) => (
                                                <Select.Option key={printer.Name} value={printer.Name}>
                                                    {printer.Name}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </React.Fragment>
                                )
                            }

                            {
                                // Export section
                                this.state.modalSelection === SELECTION__EXPORT && (
                                    <React.Fragment>
                                        <Alert
                                            showIcon={false}
                                            message={
                                                <ul>
                                                    <li>Local Path: C:\Users\Santec\Desktop\labels </li>
                                                    <li>Network Path: \\XXX.XXX.X.XX\Public </li>
                                                </ul>
                                            }
                                            banner
                                        />
                                        <div>Export location:</div>
                                        <Input
                                            defaultValue={this.state.modalExportLocation}
                                            onChange={(e) => {
                                                let pathValid =
                                                    //eslint-disable-next-line
                                                    /^((([a-zA-Z]:|\\)\\)|(\\))?(((\.)|(\.\.)|([^\\/:\*\?"\|<>\. ](([^\\/:\*\?"\|<>\. ])|([^\\/:\*\?"\|<>]*[^\\/:\*\?"\|<>\. ]))?))\\)*[^\\/:\*\?"\|<>\. ](([^\\/:\*\?"\|<>\. ])|([^\\/:\*\?"\|<>]*[^\\/:\*\?"\|<>\. ]))?$/i.test(
                                                        e.target.value
                                                        //eslint-disable-next-line
                                                    ) && /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(e.target.value);

                                                // pathValid = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(e.target.value);

                                                this.setState({ modalExportLocation: e.target.value, pathValid: pathValid });
                                            }}
                                        />
                                    </React.Fragment>
                                )
                            }
                        </Modal>

                        <div className="station-header" onClick={this.onClick}>
                            <div className="header">
                                <Text strong italic="true">
                                    {station.name} {''} (id:{station.id})
                                </Text>
                                &nbsp;
                                {this.state.collapsed ? <UpOutlined /> : <DownOutlined />}
                            </div>

                            <div
                                className="icon"
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            >
                                <React.Fragment>
                                    <Modal
                                        title="Delete Station"
                                        open={this.state.visible}
                                        onOk={this.handleOk}
                                        onCancel={() => this.setState({ visible: false })}
                                        footer={
                                            <div
                                                style={{
                                                    textAlign: 'right'
                                                }}
                                            >
                                                <Button onClick={() => this.setState({ visible: false })}>No</Button>
                                                <Button onClick={this.handleOk} type="primary">
                                                    Yes
                                                </Button>
                                            </div>
                                        }
                                    >
                                        <p>Are you sure want to delete {station.name} ?</p>
                                    </Modal>
                                </React.Fragment>

                                <React.Fragment>
                                    <Modal
                                        title="Rename Station"
                                        open={this.state.visibleRename}
                                        onOk={this.handleRenameOk}
                                        onCancel={() => this.setState({ visibleRename: false })}
                                        footer={
                                            <div className="footer">
                                                <div className="buttons">
                                                    <Button type="primary" onClick={this.handleRenameOk}>
                                                        Rename
                                                    </Button>
                                                    <Button
                                                        onClick={() => {
                                                            this.setState({ visibleRename: false });
                                                        }}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </div>
                                        }
                                    >
                                        <React.Fragment>
                                            <div>Station Name:</div>

                                            <Input
                                                defaultValue={station.name}
                                                onChange={(e) => this.setState({ newName: e.target.value })}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            />
                                        </React.Fragment>
                                    </Modal>
                                </React.Fragment>
                                <React.Fragment>
                                    <Modal
                                        title={
                                            <div className="modal-header">
                                                <div>Assign </div>
                                            </div>
                                        }
                                        open={this.state.manualVisible}
                                        onCancel={() => this.setState({ manualVisible: false })}
                                        closable={true}
                                        destroyOnClose={true}
                                        mask={true}
                                        footer={
                                            <Button
                                                type="primary"
                                                onClick={() => {
                                                    this.assignDeviceManually(this.state.deviceIp);
                                                }}
                                                loading={this.state.loading}
                                            >
                                                Assign
                                            </Button>
                                        }
                                    >
                                        <div>
                                            <div style={{ border: '2px solid blue', padding: '2px 2px 2px 2px' }}>
                                                <img style={{ width: '100%' }} src={'/RL1-Setup-XN1.png'} alt="Logo" />
                                            </div>
                                            {this.state.error && <p style={{ color: '#e60013' }}> Error : Invalid Device IP</p>}
                                            <div className="title">Device IP:</div>
                                            <Input
                                                defaultValue={this.state.deviceIp}
                                                onChange={(e) => this.setState({ deviceIp: e.target.value })}
                                            />
                                        </div>
                                    </Modal>
                                </React.Fragment>

                                <React.Fragment>
                                    <Modal
                                        title="Push Test Plan to Station"
                                        open={this.state.pushVisible}
                                        onCancel={() => this.setState({ pushVisible: false, testPlans: {} })}
                                        footer={
                                            <div className="footer">
                                                <div className="buttons">
                                                    <Button
                                                        disabled={this.state.serialNumScheme !== 'scanned'}
                                                        type="primary"
                                                        onClick={() => {
                                                            Api.pushTestPlan({
                                                                stationId: this.props.stationId,
                                                                testPlan: this.state.testPlanUUID,
                                                                retryMode: 'default',
                                                                serialNum: this.state.serialNum,
                                                                testBlocks: this.state.testBlocks
                                                            }).then((res) => {
                                                                this.setState({ pushVisible: false, testPlans: {} });
                                                            });
                                                        }}
                                                    >
                                                        Push
                                                    </Button>
                                                    <Button
                                                        onClick={() => {
                                                            this.setState({ pushVisible: false, testPlans: {} });
                                                        }}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </div>
                                        }
                                    >
                                        <React.Fragment>
                                            <div>Select a test plan:</div>
                                            <Select
                                                onChange={(testPlanId) => {
                                                    if (testPlanId) {
                                                        var result = this.state.testPlans.filter((obj) => {
                                                            return obj.id === testPlanId;
                                                        });
                                                        this.setState({
                                                            testPlanUUID: result[0].uuid,
                                                            serialNumScheme: result[0].serialNumScheme,
                                                            testBlocks: result[0].testBlocks
                                                        });
                                                    }
                                                }}
                                                style={{ width: '180px' }}
                                            >
                                                <Select.Option value={null}></Select.Option>
                                                {Object.values(this.state.testPlans).map((testPlan) => (
                                                    <Select.Option key={testPlan.id} value={testPlan.id}>
                                                        {testPlan.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>

                                            <div>Serial Number:</div>

                                            <Input
                                                value={this.state.serialNum}
                                                placeholder={
                                                    this.state.serialNumScheme === 'autogen'
                                                        ? 'Serial number is auto generated '
                                                        : 'Enter a serial number'
                                                }
                                                onChange={(e) => this.setState({ serialNum: e.target.value })}
                                            />
                                        </React.Fragment>
                                    </Modal>
                                </React.Fragment>
                                {station.name === 'Local Station' ? (
                                    <React.Fragment></React.Fragment>
                                ) : (
                                    <Button
                                        type="primary"
                                        ghost="true"
                                        shape="round"
                                        onClick={(e) => {
                                            this.setState({ discoverVisible: true });
                                            e.stopPropagation();
                                        }}
                                    >
                                        Assign Device
                                    </Button>
                                )}
                                <Dropdown
                                    trigger={['click']}
                                    overlay={
                                        <Menu>
                                            <Menu.Item
                                                key="rename"
                                                disabled={station.name === 'Local Station'}
                                                onClick={(e) => this.setState({ visibleRename: true })}
                                            >
                                                Rename
                                            </Menu.Item>
                                            <Menu.Item key="delete" onClick={() => this.setState({ visible: true })}>
                                                Delete
                                            </Menu.Item>
                                            <Menu.Item
                                                key="export"
                                                onClick={() => {
                                                    Api.getPrinters().then((printers) => this.setState({ printers: printers }));
                                                    this.setState({
                                                        modalVisible: true,
                                                        modalSelectedPrinter: null,
                                                        modalExportLocation: null
                                                    });
                                                }}
                                            >
                                                Add Print/Export
                                            </Menu.Item>
                                            <Menu.Item
                                                key="push"
                                                onClick={() => {
                                                    this.getTestPlans();
                                                    this.setState({
                                                        pushVisible: true
                                                    });
                                                }}
                                            >
                                                Push Test Plan
                                            </Menu.Item>
                                        </Menu>
                                    }
                                >
                                    <Button style={{ marginLeft: '8px' }} shape="round">
                                        Actions
                                        <DownOutlined />
                                    </Button>
                                </Dropdown>
                            </div>
                        </div>
                        <div className="body" ref={this.ref}>
                            <DeviceList devices={station.devices}>
                                {station.peripherals.map((id) => (
                                    <Peripheral
                                        key={id}
                                        id={id}
                                        peripherals={peripherals}
                                        stationId={station.id}
                                    />
                                ))}
                                <div
                                    className="device"
                                    onClick={() => {
                                        Api.getPrinters().then((printers) => this.setState({ printers: printers }));
                                        this.setState({
                                            modalVisible: true,
                                            modalSelectedPrinter: null,
                                            modalExportLocation: null
                                        });
                                    }}
                                >
                                    <div />
                                    <div />
                                    <div />
                                    <div />
                                    <div />
                                    <div />
                                </div>
                            </DeviceList>
                        </div>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

class Peripheral extends Component {
    static contextType = HardwareContext;

    static propTypes = {
        id: PropTypes.number,
        peripherals: PropTypes.object,
        stationId: PropTypes.number
    };

    render() {
        if (!(this.props.id in this.props.peripherals)) {
            return <React.Fragment />;
        }

        let peripheral = this.props.peripherals[this.props.id];

        return (
            <div className="device">
                <div className="peripheral-container">
                    <div className="title"></div>
                    <div
                        className="icon"
                        onClick={() => {
                            if (
                                peripheral.deviceTypeId === DEVICE_TYPE_ID__PRINTER ||
                                peripheral.deviceTypeId === DEVICE_TYPE_ID__FILE_STORE
                            ) {
                                Api.unassignPeripheral(this.props.id, this.props.stationId).then(() => {
                                    this.context.fetchStations();
                                });
                            }
                        }}
                    >
                        <CloseCircleOutlined />
                    </div>
                    <div className="image-box"> </div>
                    <div className="info-box">
                        {peripheral.deviceTypeId === DEVICE_TYPE_ID__PRINTER && <PrinterFilled className="peripheral-img" />}
                        {peripheral.deviceTypeId === DEVICE_TYPE_ID__FILE_STORE && (
                            <FolderOpenFilled className="peripheral-img" />
                        )}
                        <p>{peripheral.name}</p>
                    </div>
                </div>
            </div>
        );
    }
}

class DeviceDiscovery extends Component {
    static contextType = HardwareContext;

    static propTypes = {
        deviceTypes: PropTypes.array,
        devices: PropTypes.array,
        stationId: PropTypes.number
    };

    state = {
        mdnsDevices: [],
        devices: []
    };

    checkForDisconnection(device) {
        let elapsedMs = new Date() - new Date(device.lastSeenDate);
        if (elapsedMs > 60000) {
            device.status = 'Disconnected';
        }
    }

    mdnsScan() {
        Api.mdnsScan();
    }
    async refreshDeviceList() {
        let mdnsDevices = [];
        let devices = [];
        mdnsDevices = await Api.mdnsGetDevices();
        mdnsDevices.sort((a, b) => {
            let stringA = this.props.deviceTypes[a.deviceTypeId-1].name + '-' + a.uid;
            let stringB = this.props.deviceTypes[b.deviceTypeId-1].name + '-' + b.uid;
            return stringA > stringB ? 1 : -1;
        });

        await this.context.fetchDevices().then((result) => {
            if (result?.devices) {
                result.devices.forEach((device) => {
                    this.checkForDisconnection(device);
                    if (device.stationId === null && device.status !== 'Disconnected') {
                        devices.push(device);
                    }
                });
            }
        });

        this.setState({ mdnsDevices, devices });
    }

    discover() {
        this.mdnsScan();
        this.refreshDeviceList();
        this.intervalId = setInterval(() => this.refreshDeviceList(), 1000);
    }
    componentDidMount() {
        this.discover();
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    render() {
        return (
            <div id="discovered-devices">
                <Tabs defaultActiveKey="1">
                    <TabPane tab="mDNS" key="1">
                        <div className="grid expanded">
                            <div></div>
                            <div className="column-header">Model</div>
                            <div className="column-header">mDNS Name</div>
                            <div className="column-header">IP Address</div>
                            <div className="column-header">Serial Number</div>
                            <div className="column-header">Firmware</div>
                            <div className="column-header">Server</div>
                            <div></div>
                            {this.state.devices.length === 0 && this.state.mdnsDevices.length === 0 && (
                                <Spin size="large" tip="loading..." />
                            )}
                            {this.state.mdnsDevices.map((device) => {
                                if (this.props.devices.includes(device.uid)) {
                                    return <React.Fragment key={device.uid}></React.Fragment>;
                                }
                                return (
                                    <Device
                                        key={device.uid}
                                        device={device}
                                        stationId={this.props.stationId}
                                        deviceTypes={this.props.deviceTypes}
                                    />
                                );
                            })}
                        </div>
                    </TabPane>
                    <TabPane tab="Claimed Devices" key="2">
                        <div>The following devices are heart-beating to XN1. </div>
                        <div className="grid expanded">
                            <div></div>
                            <div className="column-header">Model</div>
                            <div className="column-header">mDNS Name</div>
                            <div className="column-header">IP Address</div>
                            <div className="column-header">Serial Number</div>
                            <div className="column-header">Firmware</div>
                            <div className="column-header">Server</div>
                            <div></div>
                            {this.state.devices.length === 0 && this.state.mdnsDevices.length === 0 && (
                                <Spin size="large" tip="loading..." />
                            )}

                            {this.state.devices.map((device) => {
                                if (this.props.devices.includes(device.uid)) {
                                    return <React.Fragment key={device.uid}></React.Fragment>;
                                }
                                return (
                                    <Device
                                        key={device.uid}
                                        device={device}
                                        stationId={this.props.stationId}
                                        deviceTypes={this.props.deviceTypes}
                                    />
                                );
                            })}
                        </div>
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}

class Device extends Component {
    static contextType = HardwareContext;

    static propTypes = {
        deviceTypes: PropTypes.array,
        device: PropTypes.object,
        stationId: PropTypes.number
    };

    state = {
        claimed: false
    };

    async assignDevice(e, device) {
        e.preventDefault();

        //check if the devices is from the mdns scan or from device table
        if ('id' in device) {
            this.setState({ claimed: true });
            setTimeout(() => this.context.assignDeviceToStation(device.id, this.props.stationId), 2000);
        } else {
            Api.assignServer(this.props.device.ipAddress, this.props.device.port).then((result) => {
                if (result.success === 1) {
                    this.setState({ claimed: true });
                }
            });

            setTimeout(
                () =>
                    this.context.fetchDevices().then((result) => {
                        if (result?.devices) {
                            result.devices.forEach((dev) => {
                                if (dev.uid === device.uid) {
                                    this.context.assignDeviceToStation(dev.id, this.props.stationId);
                                }
                            });
                        }
                    }),
                2000
            );
        }
    }

    render() {
        let mdnsAddress = '';
        let mdnsAddressUrl = '';
        let ipAddress = '';
        let ipAddressUrl = '';

        if (this.props.device !== undefined) {
            // Prepare IP address
            if (this.props.device.ipAddress !== null) {
                // Assume it's an IPv6 address if it contains a colon
                let ipv6 = this.props.device.ipAddress && this.props.device.ipAddress.indexOf(':') === -1 ? false : true;
                ipAddress = ipv6 ? '[' + this.props.device.ipAddress + ']' : this.props.device.ipAddress;

                // Add port if it's needed
                if (this.props.device.port && this.props.device.port !== 80) {
                    ipAddress += ':' + this.props.device.port;
                }

                ipAddressUrl = 'http://' + ipAddress;
            }

            // Prepare mDNS address
            if (this.props.device.address !== null) {
                mdnsAddress = this.props.device.address;

                // Add port if it's needed
                if (this.props.device.port !== null && this.props.device.port !== 80) {
                    mdnsAddress += ':' + this.props.device.port;
                }

                mdnsAddressUrl = 'http://' + mdnsAddress;
            }
        }

        return (
            <React.Fragment>
                <div>
                    <img
                        className="model-image"
                        src={
                            this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'RL1' ||
                            this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'RLM'
                                ? '/RLM.png'
                                : this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'OA1'
                                ? '/JGR_Cartoon_OA1_A.svg'
                                : this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'PT1'
                                ? '/PTM.png'
                                : this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'BR1' ||
                                  this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'BRM'
                                ? '/BRM.png'
                                : this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'OPM'
                                ? '/OPM.png'
                                : this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'SX1'
                                ? '/OSX.png'
                                : this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'PDL1'
                                ? '/JGR_Cartoon_PDL1_A.svg'
                                : '/RLM.png'
                        }
                        alt="Device"
                    />
                </div>

                <div>{this.props.deviceTypes[this.props.device.deviceTypeId - 1].name} </div>
                <div>
                    <a href={mdnsAddressUrl} target="_blank" rel="noopener noreferrer">
                        {mdnsAddress}
                    </a>
                </div>
                <div>
                    <a href={ipAddressUrl} target="_blank" rel="noopener noreferrer">
                        {ipAddressUrl}
                    </a>
                </div>
                <div>{this.props.device.uid}</div>
                <div>{this.props.device.firmwareVersion}</div>

                <div>
                    <a href={'http://' + this.props.device.serverAddress} target="_blank" rel="noopener noreferrer">
                        {this.props.device.serverAddress}
                    </a>
                </div>

                <div>
                    {(this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'RL1' ||
                        this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'RLM' ||
                        this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'PT1' ||
                        this.props.deviceTypes[this.props.device.deviceTypeId - 1].name === 'PTM') && (
                        <Button disabled={this.state.claimed} onClick={(e) => this.assignDevice(e, this.props.device)}>
                            {this.state.claimed ? 'Assigned' : 'Assign'}
                        </Button>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default Station;
